import { useLiquiditySummaryConfigSlice } from 'widgets/liquiditySummary/store/configuration/configSlice';
import { useSelectLocked } from 'layoutRenderer/store/selectors';
import { styleConstants } from './variables.module.constants';
import { useWidgetContext } from 'widgets/WidgetContext';

export function useLiquiditySummaryChartDimensions(): {
    hideLegends: boolean;
    headerHeight: number;
    chartContainerHeight: number;
    chartContainerMarginTop: number;
    chartHeight: number;
} {
    const { height } = useWidgetContext();
    const { config } = useLiquiditySummaryConfigSlice();

    const locked = useSelectLocked();

    const {
        hideChartOrderLeavesLegend,
        hideChartRodLegend,
        hideChartAcvLegend,
        hideChartHistVolLegend,
        hideChartTodaysVolLegend,
        hideChartAuctionVolLegend,
        hideChartTodaysAdjLegend,
        hideToolbar,
    } = config;

    const hidingAll =
        hideChartOrderLeavesLegend &&
        hideChartRodLegend &&
        hideChartAcvLegend &&
        hideChartHistVolLegend &&
        hideChartTodaysVolLegend &&
        hideChartAuctionVolLegend &&
        hideChartTodaysAdjLegend;

    const hideLegends = locked && hidingAll;

    let headerHeight = 0;

    if (locked) {
        if (hidingAll) {
            if (!hideToolbar) {
                headerHeight = styleConstants.toolbarHeight;
            }
        } else {
            const col1Height =
                countRows(
                    hideChartOrderLeavesLegend,
                    hideChartRodLegend,
                    hideChartAcvLegend
                ) * styleConstants.legendInGroupHeight;

            const col2Height =
                countRows(hideChartHistVolLegend, hideChartTodaysVolLegend) *
                styleConstants.legendInColumnHeight;
            const col3Height =
                countRows(hideChartAuctionVolLegend, hideChartTodaysAdjLegend) *
                styleConstants.legendInColumnHeight;
            headerHeight = Math.max(
                styleConstants.toolbarHeight,
                col1Height,
                col2Height,
                col3Height
            );
        }
    } else {
        headerHeight = 3 * styleConstants.legendInGroupHeight;
    }

    const chartContainerHeight =
        height -
        headerHeight -
        styleConstants.headerMargin -
        styleConstants.spaceAround * 2;

    const chartContainerMarginTop = headerHeight - styleConstants.headerMargin;

    const chartHeight = Math.min(chartContainerHeight, 120);

    return {
        hideLegends,
        headerHeight,
        chartContainerHeight,
        chartHeight,
        chartContainerMarginTop,
    };
}

function countRows(...hiddenValues: boolean[]) {
    let rows = hiddenValues.length;
    for (const hiddenValue of hiddenValues) {
        if (hiddenValue) {
            rows--;
        }
    }
    return rows;
}
